import { useContext } from "react";

import UserContext from "../context/UserContext";

export default function useCurrentUser() {
    const userInfo = useContext(UserContext);
    return userInfo?.user;
}
